<template>
  <div
    v-if="webhookDetail.type * 1 === 4"
    class="json-memember-box"
  >
    <div class="json-member-tit">
      推送数据范围：
    </div>
    <div class="json-member-content">
      <a
        href="javascript:;"
        @click="setRangeDialogShow"
      >{{ listLen ? '修改' : '设置' }}</a>
      <div
        v-if="listLen"
        class="json-memver-list scroll_bar_beautify_ff"
      >
        <span
          v-for="(item, index) in sendRangeCheckedList"
          :key="index"
          class="range-item-tit"
        >
          {{ item.name }}
          <em v-if="item.groupname">[{{ item.groupname }}]</em>
        </span>
      </div>
      <send-range-data-dialog
        ref="sendRangeDialog"
        :datas="defaultVal"
        @getRangeH="getRangeH"
      />
    </div>
  </div>
</template>
<script>
import SendRangeDataDialog from './SendRangeDataDialog'
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  components: {
    SendRangeDataDialog
  },
  props: {
    rangeData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('config/webhook', ['sendRangeCheckedData', 'webhookDetail']),
    ...mapGetters('config/webhook', ['currentRangeDatas']),
    defaultVal () {
      let arr = []
      const { sendRangeCheckedData = [] } = this
      arr = sendRangeCheckedData.map(item => {
        const keysArr = Object.keys(item)
        let key = ''
        if (keysArr.includes('roleid') && keysArr.includes('groupid') && keysArr.includes('userid')) {
          key = `roleid-${item.roleid}|groupid-${item.groupid}|userid-${item.userid}`
        } else if (keysArr.includes('roleid') && keysArr.includes('groupid')) {
          key = `roleid-${item.roleid}|groupid-${item.groupid}`
        } else if (keysArr.includes('userid')) {
          key = `userid-${item.userid}`
        } else if (keysArr.includes('roleid')) {
          key = `roleid-${item.roleid}`
        }
        return { key, name: item.name }
      })
      return arr
    },
    listLen () {
      return this.sendRangeCheckedData.length > 0
    },
    // 处理后的添加小组后数据
    sendRangeCheckedList () {
      const { sendRangeCheckedData = [], currentRangeDatas = [] } = this
      sendRangeCheckedData.forEach((item, index) => {
        const keyArr = Object.keys(item)
        if (keyArr.includes('groupid') && keyArr.includes('userid')) {
          this.sendRangeDatasLoop(sendRangeCheckedData, item, index, currentRangeDatas)
        }
      })
      return sendRangeCheckedData
    }
  },
  // watch: {
  //   // 监听选中范围，并对选中的有组的成员添加小组名称
  //   sendRangeCheckedData: {
  //     handler (val) {
  //       if (val.length > 0) {
  //         this.sendRangeCheckedList = []
  //         val.forEach((item, index) => {
  //           const keyArr = Object.keys(item)
  //           if (keyArr.includes('groupid') && keyArr.includes('userid')) {
  //             this.sendRangeDatasLoop(val, item, index, this.currentRangeDatas)
  //           }
  //         })
  //         this.sendRangeCheckedList = val
  //       }
  //     },
  //     deep: true
  //   }
  // },
  mounted () {
  },
  methods: {
    ...mapActions('config/webhook', ['getRangeTreeDatas']),
    // 显示获取推送数据范围弹窗
    setRangeDialogShow () {
      this.$refs.sendRangeDialog.changeLimitDialog(true)
    },
    // 递归循环添加小组数据
    sendRangeDatasLoop (arr, i, index, currentRangeDatas) {
      currentRangeDatas.forEach(item => {
        if (item.keyname === 'groupid' && item.id === i['groupid'] * 1) {
          arr[index].groupname = item.name
        } else {
          if (item.children && item.children.length > 0) {
            this.sendRangeDatasLoop(arr, i, index, item.children)
          }
        }
      })
    },
    getRangeH () {
      this.$emit('getRangeH')
    }
  }
}
</script>
<style lang="scss" scoped>
  .json-memember-box {
    position: relative;
    padding-left: 110px;
    margin-bottom: 24px;
    padding-top: 8px;
    .json-member-tit {
      position: absolute;
      left: 0;
      color: #666;
    }
    .json-memver-list {
      margin-top: 4px;
      max-height: 260px;
      overflow-y: auto
    }
    .range-item-tit {
        border-radius: 4px;
        line-height: 20px;
        height: 20px;
        border: 1px solid #ebebeb;
        display: inline-block;
        color: #666;
        padding: 0 8px;
        font-weight: 400;
        font-size: 12px;
        margin: 12px 16px 0 0;
         em {

          color:#b3b3b3 ;
          font-style: normal;
          margin-right: 1px;
          padding-right: 3px;
        }
      }
  }
</style>
